// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ck-b";
export var colorBlue = "_ck-8";
export var colorDot = "_ck-0";
export var colorDotLarge = "_ck-2";
export var colorDotSmall = "_ck-1";
export var colorGreen = "_ck-7";
export var colorGrey = "_ck-3";
export var colorOrange = "_ck-5";
export var colorPink = "_ck-a";
export var colorPurple = "_ck-9";
export var colorRed = "_ck-4";
export var colorYellow = "_ck-6";